import React from "react";
import { Box, Typography, Grid, Paper, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
    IMG_SWEATSHIRT_BLACK_MAIN as SweatshirtImg,
    IMG_DAINASOUL_TERRY_SHORTS_RED as ShortsImg,
    IMG_DAINASOUL_CAP_CREAM as AccessoriesImg
} from "./imageConfig";

// categories data
const categories = [
    {
        title: "Ready to Wear",
        path: "/products/ready-to-wear",
        items: [
            { name: "Sweatshirts", path: "/products/sweatshirts", tag: "Coming in Winter" },
            { name: "Hoodies", path: "/products/hoodies", tag: "Coming in Winter" },
            { name: "Shorts", path: "/products/shorts", tag: "Coming Soon" },
            { name: "T-Shirts & Tops", path: "/products/t-shirts & tops" },
        ],
    },
    {
        title: "Accessories",
        path: "/products/accessories",
        tag: "Coming Soon",
        items: [
            { name: "Bags", path: "/products/bags", tag: "Coming Soon" },
            { name: "Caps", path: "/products/caps", tag: "Coming Soon" },
        ],
    },
    {
        title: "Edits",
        path: "/all-products",
        tag: "Coming Soon",
        items: [
            { name: "Fall Essentials", path: "/products/fall-essentials", tag: "Coming Soon" },
            { name: "Matching Sets", path: "/products/matching-sets", tag: "Coming Soon" },
            { name: "Tonal Classics", path: "/products/tonal-classics", tag: "Coming Soon" },
        ],
    },
];

const promoImages = [
    {
        src: SweatshirtImg,
        label: "SWEATSHIRTS",
        path: "/products/sweatshirts",
        tag: "Coming in Winter"
    },
    {
        src: ShortsImg,
        label: "SHORTS",
        path: "/products/shorts",
        tag: "Coming Soon"
    },
    {
        src: AccessoriesImg,
        label: "ACCESSORIES",
        path: "/products/accessories",
        tag: "Coming Soon"
    },
];

const ShopDropdown = ({ onClose, onMouseEnter }) => {
    const navigate = useNavigate();

    const handleLinkClick = (path, hasTag) => {
        // We now allow clicking even if there's a tag, so the user can see the "Coming Soon" page in CategoryPage.js
        navigate(path);
        onClose();
    };

    return (
        <Paper
            elevation={4}
            sx={{
                p: { xs: 2, md: 2 }, // Reduced padding
                mt: 0,
                backgroundColor: "#fff",
                borderRadius: 0,
                boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
                width: "100%",
                maxWidth: "100vw",
                left: 0,
                right: 0,
                position: 'fixed',
                zIndex: 1300,
                borderTop: "1px solid #f0f0f0",
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onClose}
        >
            <Grid
                container
                spacing={0}
                sx={{
                    width: '100%',
                    pl: { xs: 2, md: 2 }, // Shift left side closer to edge
                    pr: { xs: 2, md: 7 }  // Keep right side balanced
                }}
            >
                {/* Categories Section (Left side - 50% width) */}
                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        <Grid container spacing={4}>
                            {categories.map((category) => (
                                <Grid item xs={4} key={category.title}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                                        <Link
                                            component="button"
                                            onClick={() => handleLinkClick(category.path, !!category.tag)}
                                            underline="none"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                color: category.tag ? "#999" : "#000",
                                                fontFamily: "inherit",
                                                textAlign: "left",
                                                display: "block",
                                                cursor: category.tag ? "default" : "pointer",
                                                "&:hover": {
                                                    color: category.tag ? "#999" : "#888",
                                                },
                                            }}
                                        >
                                            {category.title}
                                        </Link>
                                        {category.tag && (
                                            <Typography
                                                sx={{
                                                    fontSize: "10px",
                                                    color: "#888",
                                                    fontStyle: "italic",
                                                    fontWeight: 400
                                                }}
                                            >
                                                ({category.tag})
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                        {category.items.map((item) => (
                                            <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Link
                                                    component="button"
                                                    onClick={() => handleLinkClick(item.path, !!item.tag)}
                                                    underline="none"
                                                    sx={{
                                                        textAlign: "left",
                                                        color: item.tag ? "#999" : "#000",
                                                        fontSize: "11px",
                                                        fontWeight: 700,
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.8px",
                                                        transition: "color 0.2s",
                                                        cursor: item.tag ? "default" : "pointer",
                                                        "&:hover": {
                                                            color: item.tag ? "#999" : "#888",
                                                        },
                                                    }}
                                                >
                                                    {item.name}
                                                </Link>
                                                {item.tag && (
                                                    <Typography
                                                        sx={{
                                                            fontSize: "9px",
                                                            color: "#888",
                                                            fontStyle: "italic",
                                                            textTransform: "none",
                                                            letterSpacing: "0.5px",
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        — {item.tag}
                                                    </Typography>
                                                )}
                                            </Box>
                                        ))}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    <Box sx={{ mt: 'auto', pb: 1 }}>
                        <Link
                            component="button"
                            onClick={() => handleLinkClick('/all-products')}
                            underline="none"
                            sx={{
                                color: "#000",
                                fontSize: "11px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                borderBottom: "1.5px solid #000",
                                letterSpacing: "1px",
                                "&:hover": {
                                    color: "#888",
                                },
                            }}
                        >
                            Shop All Products
                        </Link>
                    </Box>
                </Grid>

                {/* Promo Images Section (Right side - 50% width) */}
                <Grid item xs={12} md={6}>
                    <Grid container spacing={0}>
                        {promoImages.map((promo, index) => (
                            <Grid item xs={4} key={index}>
                                <Box
                                    onClick={() => handleLinkClick(promo.path, !!promo.tag)}
                                    sx={{
                                        cursor: promo.tag ? "default" : "pointer",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        height: '100%',
                                        position: 'relative' // For absolute tag positioning if needed
                                    }}
                                >
                                    <Box sx={{ flexGrow: 0, width: '100%', position: 'relative' }}>
                                        <Box
                                            component="img"
                                            src={promo.src}
                                            alt={promo.label}
                                            sx={{
                                                width: "100%",
                                                height: "auto",
                                                aspectRatio: "3/4",
                                                objectFit: "cover",
                                                mb: 2,
                                                transition: "opacity 0.2s",
                                                opacity: promo.tag ? 0.7 : 1,
                                                "&:hover": {
                                                    opacity: promo.tag ? 0.7 : 0.9,
                                                },
                                            }}
                                        />
                                        {promo.tag && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 10,
                                                    left: 10,
                                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                                    padding: '2px 6px',
                                                    borderRadius: '2px',
                                                    backdropFilter: 'blur(4px)'
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '8px',
                                                        fontWeight: 700,
                                                        color: '#000',
                                                        letterSpacing: '0.5px'
                                                    }}
                                                >
                                                    {promo.tag.toUpperCase()}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            textTransform: "uppercase",
                                            letterSpacing: "1px",
                                            textAlign: "left",
                                            color: promo.tag ? "#888" : "#000",
                                            mt: 'auto',
                                            pb: 1
                                        }}
                                    >
                                        {promo.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ShopDropdown;
